// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {Fragment, useState, useContext, useRef, useEffect} from 'react';
import cn from 'classnames';
import styles from './breadcrumbs.module.less';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import {Settings_context} from '../settings_ctx';
import {use_screen} from '../lib/screen_util';

interface i_breadcrumbs_props {
    breadcrumbs: {title: string; link: string}[];
}

const Breadcrumbs_items = ({breadcrumbs}: i_breadcrumbs_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.breadcrumbs}>
      {breadcrumbs.map(({title, link}, index)=>{
        const cls = cn(theme.p4,
            {
              [styles.active]: index == breadcrumbs.length - 1,
              [theme.color_n600]: index != breadcrumbs.length - 1
            });
        return <Fragment key={index}>
          {index > 0 && <span className={styles.divider}>&gt;</span>}
          <a href={link}><p className={cls}>{title}</p></a>
        </Fragment>;
      })}
    </div>;
};

export const Breadcrumbs = ({breadcrumbs}: i_breadcrumbs_props)=>{
    const {theme} = useContext(Settings_context);
    const {screen} = use_screen();
    const ref = useRef<HTMLDivElement>(null);
    const [cls, set_cls] = useState(null);
    useEffect(()=>{
        set_cls(screen!='xs' ? theme.container : null);
    }, [screen, set_cls]);
    useEffect(()=>{
        if (ref.current)
        {
            ref.current.scrollTo({
                left: 10000,
                behavior: 'smooth',
            });
        }
    }, [ref]);
    return <div className={cls}>
      <div ref={ref} className={styles.breadcrumbs_container}>
        <Breadcrumbs_items breadcrumbs={breadcrumbs} />
      </div>
    </div>;
};

interface i_breadcrumbs_editor_props {
    value: i_breadcrumbs_props;
    on_change: (new_value: i_breadcrumbs_props)=>void;
    on_cancel: ()=>void;
}

export const Breadcrumbs_editor = (
    props: i_breadcrumbs_editor_props
)=>{
    const {value, on_change, on_cancel} = props;
    const [state, set_state] = useState<i_breadcrumbs_props>({
      breadcrumbs: value.breadcrumbs || [],
    });
    return <Editor
      value={state} on_change={on_change} on_cancel={on_cancel}
      on_save={()=>on_change(state)}
      editors={[]} title="Breadcrumbs">
      <Fragment>
        {state.breadcrumbs.map((breadcrumb, i)=><div key={i}>
            <Editor
              editors={[
                {key: 'title', label: 'Title', type: 'text'},
                {key: 'link', label: 'Link', type: 'text'},
              ]}
              value={breadcrumb}
              on_change={(b: typeof breadcrumb)=>{
                const new_items = [...state.breadcrumbs];
                new_items[i] = b;
                set_state({breadcrumbs: new_items});
              }}/>
            <Button caption="Delete item" size="xs"
              on_click={()=>{
                set_state({
                  breadcrumbs: state.breadcrumbs
                    .filter((_, index)=>index!==i)
                });
              }}/>
            <hr/>
          </div>)}
        <Button caption="Add new item" size="xs"
          on_click={()=>set_state({
            breadcrumbs: [
              ...state.breadcrumbs,
              {title: '', link: ''},
            ],
          })}/>
      </Fragment>
    </Editor>;
};
